import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

type MarkNotHiredDialogProps = {
  open: boolean;
  providerName: string | undefined;
  onOpenChange: (open: boolean) => void;
  onCancel: () => void;
  onConfirm: () => void;
  isPending?: boolean;
  isConfirmDisabled?: boolean;
};

export function MarkNotHiredDialog({
  open,
  providerName,
  onOpenChange,
  onCancel,
  onConfirm,
  isPending = false,
  isConfirmDisabled = false,
}: MarkNotHiredDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Mark as not hired?</DialogTitle>
          <DialogDescription>
            <span className="font-medium text-foreground">{providerName}</span>{" "}
            will stay on your provider list as a candidate and will no longer be
            marked hired.
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="mt-6 border-t pt-4 gap-2 sm:space-x-0">
          <Button
            variant="outline"
            className="w-full lg:w-auto"
            onClick={onCancel}
            disabled={isPending}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            className="w-full lg:w-auto"
            disabled={isPending || isConfirmDisabled}
            onClick={onConfirm}
          >
            {isPending ? (
              <span className="flex items-center gap-2">
                <Loader2 className="h-4 w-4 animate-spin" />
                Saving...
              </span>
            ) : (
              "Mark not hired"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
